import React from "react";
import "./border-input.scss";

export const BorderInput = ({
  iconLeft,
  iconRight,
  col,
  placeHolder,
  name,
  type,
  value,
  onChange,
  adjustMargin,
  error,
  className,
}) => {
  return (
    <>
      <div
        className={`d-inline-flex flex-column text-white ${className} ${col} ${
          adjustMargin ? adjustMargin : ""
        }`}
      >
        <div className="input-container-border position-relative">
          {/* Left icon */}
          {iconLeft && (
              <span className="position-absolute top-50 start-0 translate-middle-y ps-3">
      {iconLeft}
    </span>
          )}
          <input
            autoComplete={false}
            placeholder={placeHolder}
            onChange={onChange}
            name={name}
            value={value}
            type={type}
            className="col-12 bg-transparent border-0 input-border text-white "
          />
          {iconRight && (
              <span className="position-absolute top-50 end-0 translate-middle-y pe-3">
      {iconRight}
    </span>
          )}
        </div>
        {error ? (
          <h6 className="mt-lg-2 pb-0 text-danger error-style">{error}</h6>
        ) : null}
      </div>
    </>
  );
};
